const initialState = () => ({
  dashboards: [],
  selectedDashboard: null
})


export default initialState
